// frontend/src/site/builder/sections/HeroForm.jsx
import React from 'react';

function Label({ children }) {
  return <div className="text-sm font-medium text-gray-800">{children}</div>;
}

function Input({ value, onChange, placeholder = '', type = 'text' }) {
  return (
    <input
      type={type}
      value={value || ''}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder={placeholder}
      className="mt-2 w-full px-3 py-2 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-black/10"
    />
  );
}

function Textarea({ value, onChange, placeholder = '' }) {
  return (
    <textarea
      value={value || ''}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder={placeholder}
      className="mt-2 w-full px-3 py-2 rounded-lg border border-gray-200 min-h-[110px] focus:outline-none focus:ring-2 focus:ring-black/10"
    />
  );
}

function Select({ value, onChange, children }) {
  return (
    <select
      value={value || ''}
      onChange={(e) => onChange?.(e.target.value)}
      className="mt-2 w-full px-3 py-2 rounded-lg border border-gray-200 bg-white"
    >
      {children}
    </select>
  );
}

function Switch({ checked, onChange, label }) {
  return (
    <button
      type="button"
      onClick={() => onChange?.(!checked)}
      className="flex items-center justify-between w-full"
    >
      <div className="text-sm text-gray-800">{label}</div>
      <div
        className={`w-12 h-7 rounded-full relative transition ${checked ? 'bg-black' : 'bg-gray-300'}`}
      >
        <span
          className={`absolute top-1 left-1 w-5 h-5 rounded-full bg-white transition ${checked ? 'translate-x-5' : ''}`}
        />
      </div>
    </button>
  );
}

export default function HeroForm({ value = {}, onChange }) {
  const v = value || {};

  function patch(p) {
    onChange?.(p);
  }

  const primary = v.primaryCta || {};
  const secondary = v.secondaryCta || {};

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div className="md:col-span-2">
          <Label>Nome em destaque</Label>
          <Input
            value={v.nome}
            onChange={(x) => patch({ nome: x })}
            placeholder="Ex: Ricardo Silva"
          />
        </div>

        <div className="md:col-span-2">
          <Label>Título (linha de autoridade)</Label>
          <Input
            value={v.titulo}
            onChange={(x) => patch({ titulo: x })}
            placeholder="Ex: Especialista em imóveis residenciais e investimentos"
          />
        </div>

        <div className="md:col-span-2">
          <Label>Frase de posicionamento (curta)</Label>
          <Textarea
            value={v.frase}
            onChange={(x) => patch({ frase: x })}
            placeholder="Ex: Atendimento personalizado e segurança em cada negociação."
          />
        </div>
      </div>

      <div className="rounded-xl border border-gray-200 p-4">
        <div className="font-medium text-gray-900">Botão Principal</div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-3">
          <div>
            <Label>Texto do botão</Label>
            <Input
              value={primary.label}
              onChange={(x) => patch({ primaryCta: { ...primary, label: x } })}
              placeholder="Ex: Falar no WhatsApp"
            />
          </div>

          <div>
            <Label>Ação</Label>
            <Select
              value={primary.action}
              onChange={(x) => patch({ primaryCta: { ...primary, action: x } })}
            >
              <option value="">Selecione</option>
              <option value="whatsapp">Abrir WhatsApp</option>
              <option value="imoveis">Ir para seção Imóveis</option>
              <option value="contato">Ir para seção Contato</option>
              <option value="url">Abrir URL</option>
            </Select>
          </div>

          <div>
            <Label>URL (se ação = URL)</Label>
            <Input
              value={primary.url}
              onChange={(x) => patch({ primaryCta: { ...primary, url: x } })}
              placeholder="https://..."
            />
          </div>
        </div>
      </div>

      <div className="rounded-xl border border-gray-200 p-4 space-y-3">
        <Switch
          checked={!!v.showSecondaryCta}
          onChange={(x) => patch({ showSecondaryCta: x })}
          label="Ativar botão secundário"
        />

        {v.showSecondaryCta ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <div>
              <Label>Texto do botão</Label>
              <Input
                value={secondary.label}
                onChange={(x) =>
                  patch({ secondaryCta: { ...secondary, label: x } })
                }
                placeholder="Ex: Ver Imóveis"
              />
            </div>

            <div>
              <Label>Ação</Label>
              <Select
                value={secondary.action}
                onChange={(x) =>
                  patch({ secondaryCta: { ...secondary, action: x } })
                }
              >
                <option value="">Selecione</option>
                <option value="imoveis">Ir para seção Imóveis</option>
                <option value="sobre">Ir para seção Sobre</option>
                <option value="contato">Ir para seção Contato</option>
                <option value="url">Abrir URL</option>
              </Select>
            </div>

            <div>
              <Label>URL (se ação = URL)</Label>
              <Input
                value={secondary.url}
                onChange={(x) =>
                  patch({ secondaryCta: { ...secondary, url: x } })
                }
                placeholder="https://..."
              />
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
